import { useCallback, useState } from 'react';

import { useShallow } from 'zustand/react/shallow';

import { useRoomStore } from '@src/stores';
import { useSettingsContext } from '@src/contexts';

import { TLayoutItems } from '@src/types';

const useViewLayoutModal = () => {
  const { selectedLayout, handleChangeLayout } = useSettingsContext();

  const [selectedOption, setSelectedOption] = useState<TLayoutItems>(selectedLayout);

  const { isViewLayoutOpen, setIsViewLayoutOpen } = useRoomStore(
    useShallow((state) => ({
      isViewLayoutOpen: state.isViewLayoutOpen,
      setIsViewLayoutOpen: state.setIsViewLayoutOpen,
    }))
  );

  const handleApply = useCallback(() => {
    setIsViewLayoutOpen(false);
    handleChangeLayout(selectedOption);
  }, [handleChangeLayout, selectedOption, setIsViewLayoutOpen]);

  const handleCloseModal = useCallback(() => {
    setIsViewLayoutOpen(false);
    setSelectedOption(selectedLayout);
  }, [selectedLayout, setIsViewLayoutOpen]);

  return { selectedOption, isViewLayoutOpen, handleApply, handleCloseModal, setSelectedOption };
};

export default useViewLayoutModal;
